import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncUploadKYC = loadable(() => import('./UploadKYC'), {
  fallback: <Loader />,
});
